module.exports = __webpack_public_path__ + "assets/img/1.516bbac6.gif";